import { isProduction } from '../utils';

import { sendSlackMessage } from './api/slack';

export const sendSlackDemoNotification = async (props: {
  action: string;
  user: { email: string; elementId?: string };
  details?: string;
  isError?: boolean;
}) => {
  const { action, user, details, isError } = props;

  const channel = 'C0BMTAEJ010';

  const text =
    `## ${isError ? ':warning: ERROR – ' : ''}${action}` +
    `\n**User**: <mailto:${user.email}|${user.email}>${user.elementId ? ` – \`${user.elementId}\`` : ''}` +
    `${details ? `\n**Details**: ${details}` : ''}` +
    (isProduction() ? '' : '\n\n_Staging environment_');

  await sendSlackMessage(channel, encodeURIComponent(text));
};
